var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { getLocale, setLocale, onLocaleChange, LOCALES, t } from '../i18n';
import './vitesse-dropdown';
/*
 * <vitesse-language-switcher> — language picker. Thin wrapper over the shared
 * <vitesse-dropdown>; languages are listed in their OWN names (autonyms, never
 * translated). Selecting lazy-loads the dictionary + live-updates the whole UI.
 */
let LanguageSwitcher = class LanguageSwitcher extends LitElement {
    constructor() {
        super(...arguments);
        this.locale = getLocale();
    }
    connectedCallback() {
        super.connectedCallback();
        this.unsub = onLocaleChange((l) => (this.locale = l)); // re-mark the active language
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.unsub?.();
    }
    render() {
        const items = LOCALES.map((l) => ({ value: l.code, label: l.label }));
        return html `<vitesse-dropdown
      .triggerIcon=${'languages'}
      .triggerTitle=${t('header.language')}
      .items=${items}
      .value=${this.locale}
      @dropdown-select=${(e) => void setLocale(e.detail.value)}
    ></vitesse-dropdown>`;
    }
};
__decorate([
    state()
], LanguageSwitcher.prototype, "locale", void 0);
LanguageSwitcher = __decorate([
    customElement('vitesse-language-switcher')
], LanguageSwitcher);
export { LanguageSwitcher };
//# sourceMappingURL=language-switcher.js.map